import * as React from 'react'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { withRouter } from 'react-router'
import HttpActionsService from '../../../Services/HttpActionsService'
import ExternalDataStore from '../../../Stores/ExternalDataStore'
import NotificationsStore, { NotificationEntity } from '../../../Stores/NotificationsStore'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'

export interface IExternalDataSearchByPINPageProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    externalDataStore: ExternalDataStore
    notificationsStore: NotificationsStore
}

@inject('localizationStore')
@inject('httpActionsService')
@inject('externalDataStore')
@inject('notificationsStore')

@observer
class ExternalDataSearchByPINPage 
        extends React.Component<IExternalDataSearchByPINPageProps> {

    constructor(props: any) {
        super(props)
    }

    componentDidMount() {
        const pin = this.props['match']!['params']['pin']
        if (pin) {
            this.props.httpActionsService!.getClientGovDataByPin(pin)
        } else {
            this.props.notificationsStore
                .addAlert(
                    new NotificationEntity(
                        'danger', 
                        this.props.localizationStore!.t('no pin in query params!')
                    )
                )
        }
    }

    render() {
        const { externalDataStore, localizationStore } = this.props

        const data = externalDataStore!.getClientGovDataByPin!

        if (externalDataStore!.isError || !data) {
            return(<div>{localizationStore!.t('No data text')}</div>)
        }
        
        return (
            <div className="external-data-page external-data-credit-info-items-view">
                <h6 className="getExternalData">
                    {localizationStore!.t!('Get external data by PIN')}
                </h6>
                <ul className="externalDataPINInfo">
                    <li>
                        <label>{localizationStore!.t('pin')}</label>:&nbsp;
                        <span>{data!['pin']}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('lastName')}</label>:&nbsp;
                        <span>{data!['lastName']}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('firstName')}</label>:&nbsp;
                        <span>{data!['firstName']}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('middleName')}</label>:&nbsp;
                        <span>{data!['middleName']}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('dateOfBirth')}</label>:&nbsp;
                        <span>{DateTimeHelper.formatDateForList(data!['dateOfBirth'])}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('passportNumberSeria')}</label>:&nbsp;
                        <span>{data!['passportSeria']}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('passportGivenBy')}</label>:&nbsp;
                        <span>{data!['passportGivenBy']}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('dateOfIssue')}</label>:&nbsp;
                        <span>{DateTimeHelper.formatDateForList(data!['dateOfIssue'])}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('passportExpires')}</label>:&nbsp;
                        <span>{DateTimeHelper.formatDateForList(data!['passportExpires'])}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('city')}</label>:&nbsp;
                        <span>{data!['city']}</span>
                    </li>
                    <li>
                        <label>{localizationStore!.t('address')}</label>:&nbsp;
                        <span>{data!['address']}</span>
                    </li>
                </ul>
            </div>
        )
    }
}

export default withRouter(ExternalDataSearchByPINPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ExternalDataPages/ExternalDataSearchByPinPage.tsx